import { useMutation, useQueryClient } from "@tanstack/react-query";

import { orvalClient } from "@/api";
import {
  VideoVisitConsentResponse,
  getVideoVisitConsentQueryKey,
} from "@/api/queries/videoVisitConsent";

interface VideoVisitConsentRequest {
  encounter_id: string;
  consented: boolean;
}

/**
 * Records the patient's per-encounter consent to record (and use AI on) the
 * video visit. `mutate(true)` grants, `mutate(false)` explicitly declines.
 */
export const useSetVideoVisitRecordingConsent = (
  encounterId?: string | null,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (consented: boolean) =>
      orvalClient<VideoVisitConsentResponse, VideoVisitConsentRequest>({
        url: "/clinic/video-visit/consent",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        data: { encounter_id: encounterId ?? "", consented },
      }),
    onSuccess: (data) => {
      // Reflect the new value immediately, then refetch to confirm.
      queryClient.setQueryData(getVideoVisitConsentQueryKey(encounterId), data);
      queryClient.invalidateQueries({
        queryKey: getVideoVisitConsentQueryKey(encounterId),
      });
    },
  });
};
